// import { clientBase } from "../common";

export const updateImage = (_image) => {
  // return clientBase(`v2/userImage`, "PUT",  {body: _image}  );

  const token = window.localStorage.getItem("a_t");
  const headers = { "content-type": "multipart/form-data" };
  if (token) headers.Authorization = `Bearer ${token}`;


  const config = {
    method: "POST",
    headers: {
      ...headers,
    },
    body: _image,
  };

  return window
    .fetch(`${process.env.VUE_APP_URL}/api/v2/userImage`, config)
    .then(async (response) => {
      if (response.ok) return await response.json();
    });
};
